import {
    timedGet, logError
} from './ec9xns-connection';

import {ScannerFirmwareUpdateFailure} from './ec9xns-error';


const pkgSeqPrefix = Math.floor(new Date().getTime() / 1000).toString(16);
let pkgSequence = 1;


function getISODateString2() {
    const pad = (num) => {
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
    };

    const now = new Date();
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
}


// eslint-disable-next-line no-unused-vars
function basename(str) {
    let base = String(str).substring(String(str).lastIndexOf('/') + 1);
    if (base.lastIndexOf('.') !== -1) {
        base = base.substring(0, base.lastIndexOf('.'));
    }
    return base;
}

function basefile(str) {
    return String(str).replace(/\\/g, '/').substring(String(str).lastIndexOf('/') + 1);
}

/**
 * Robust version comparator:
 * - Extrae todos los grupos numéricos de la cadena (major, minor, patch, build, etc.)
 * - Compara numéricamente segmento a segmento con zero-fill
 *   Ej: '1.3.1-0069' -> [1,3,1,69], '1.3.1+0065' -> [1,3,1,65]
 */
function compareSemanticVersion(aVersion, bVersion, options) {
    const toNumSegments = (v) => {
        if (!v || typeof v !== 'string') return [0];
        const m = v.match(/\d+/g);
        return m ? m.map(n => parseInt(n, 10)) : [0];
    };

    const A = toNumSegments(aVersion);
    const B = toNumSegments(bVersion);
    const len = Math.max(A.length, B.length);

    for (let i = 0; i < len; i++) {
        const av = (i < A.length) ? A[i] : 0;
        const bv = (i < B.length) ? B[i] : 0;
        if (av > bv) return 1;
        if (av < bv) return -1;
    }
    return 0;
}


/*
 * Firmware Update Functions
 */

const EC9xSFU_STEPS = [
    'Downloading Update from Server',
    'Sending Update into Scanner',
    'Installing Update'
];


class EC9xSFUProgressEvent {
    constructor(xStep, xPercent = 100) {
        this.currentStep = xStep;
        this.done = (xPercent < 100);
        this.currentPercent = Math.floor(xPercent);
        this.details = [];
    }

    get isDone() {
        return this.done;
    }

    get currentStepName() {
        return this.currentStep;
    }

    get currentStepPercent() {
        return this.currentPercent;
    }

    get installationDetails() {
        return [...this.details];
    }

    setDone() {
        this.done = true;
        return this;
    }

    setCurrentStepPercent(xValue) {
        this.currentPercent = Math.floor(xValue);
        return this;
    }

    appendDetails(xDetails) {
        if (xDetails) {
            if (Array.isArray(xDetails)) {
                xDetails.forEach((cLn) => {
                    this.details.push(cLn);
                });
            } else {
                this.details.push(String(xDetails));
            }
        }
        return this;
    }
}


class EC9xSfuAbsctractUpdateMeta {
}


class EC9xSfuUpdateMeta extends EC9xSfuAbsctractUpdateMeta {
    constructor(values = {}) {
        super();

        this.seqID = `${pkgSeqPrefix}-${pkgSequence}`;

        pkgSequence = pkgSequence + 1;
        if (pkgSequence > Number.MAX_VALUE - 1000) {
            pkgSequence = 1;
        }

        if (values instanceof Map) {
            values = Object.fromEntries(values);
        }

        this.type = ('type' in values) ? values.type : null;
        this.version = ('availableVersion' in values) ? values.availableVersion : null;
        this.requiredDate = ('requiredDate' in values) ? values.requiredDate : null;
        this.name = ('displayName' in values) ? values.displayName : null;
        this.details = ('details' in values) ? values.details : 'N/A';
        this.license = ('licenseHtml' in values) ? values.licenseHtml : 'N/A';
        this.licenseUrl = ('licenseUrl' in values) ? values.licenseUrl : null;
        this.url = ('pkgURL' in values) ? values.pkgURL : null;
    }

    getUpdateId() {
        return this.seqID;
    }

    getUpdateType() {
        return this.type;
    }

    getUpdateVersion() {
        return this.version;
    }

    isUpdateRequired() {
        if (this.requiredDate) {
            const dateVal = Date.parse(this.requiredDate);
            if (isNaN(dateVal)) {
                return false;
            }
            return (Date.now() > dateVal);
        }
        return false;
    }

    getUpdateName() {
        return this.name;
    }

    getUpdateDetails() {
        return this.details;
    }

    getUpdateLicenseHtml() {
        return this.license;
    }

    getUpdateLicenseUrl() {
        return this.licenseUrl;
    }

    getUpdateUrl() {
        return this.url;
    }

    getInstallBeforeDate() {
        return this.requiredDate;
    }
}


/**********************************************************
 * Workers
 *********************************************************/

class EC9xSfuManualUpdateWorker {
    constructor(scannerUrl) {
        this.scannerUrl = scannerUrl;
    }

    /**
     * @override
     */
    doStartUpdate() {
        const aScannerUrl = this.scannerUrl;
        return new Promise((resolve) => {
            window.open(`${aScannerUrl}/#refadmin`);
            resolve(true);
        });
    }

    /**
     * @override
     */
    doGetExectorType() {
        return 'Manual';
    }
}


class EC9xNSAPIBaseWorker {
    constructor() {
        const that = this;
        this.STATUSES = {
            IDLE: 0,
            RUNING: 1,
            DONE: 2,
        };

        this.status = this.STATUSES.IDLE;

        this.doRetrieveBinaryXHR = (xUrl, xEventListener, respType) => {

            that.fireProgressEvent(xEventListener,
                new EC9xSFUProgressEvent(EC9xSFU_STEPS[0], 0), true);

            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();

                xhr.open('GET', xUrl, true);
                xhr.responseType = respType;

                that.regXHRListener(xhr, 'progress', (cProgressEvt) => {
                    if (cProgressEvt.lengthComputable && cProgressEvt.total > 0) {
                        that.fireProgressEvent(xEventListener,
                            new EC9xSFUProgressEvent(EC9xSFU_STEPS[0],
                                ((cProgressEvt.loaded / cProgressEvt.total) * 100)));
                    }
                });

                that.regXHRListener(xhr, 'readystatechange', () => {
                    // Call a function when the state changes.
                    try {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                that.fireProgressEvent(xEventListener,
                                    new EC9xSFUProgressEvent(EC9xSFU_STEPS[0], 100),
                                    true);
                                resolve(xhr.response);
                            } else {
                                reject(new Error(`Error happened during downloading firmware! - HTTP ${xhr.status}`));
                            }
                        }
                    } catch (e) {
                        reject(new Error(`Error happened during downloading firmware! - ${e.toString()}`));
                    }
                });
                xhr.send();
            });
        };

        this.doRetrieveBinaryAsArray = (xUrl, xEventListener) => {
            return this.doRetrieveBinaryXHR(xUrl, xEventListener, 'arraybuffer');
        };

        this.doRetrieveBinaryAsBlob = (xUrl, xEventListener) => {
            return this.doRetrieveBinaryXHR(xUrl, xEventListener, 'blob');
        };

        this.regXHRListener = (obj, evt, func) => {
            if (obj.addEventListener) {
                obj.addEventListener(evt, func, false);
            } else {
                obj.attachEvent(`on${evt}`, func);
            }
        };

        this.fireProgressEvent = (xListener, xEvent, xForce = false) => {
            if (xListener && ((xEvent.currentStepPercent > 1
                && xEvent.currentStepPercent < 99) || xForce
            )) {
                xListener(xEvent);
            }
        };

        this.doHandleUploadResp = (xXhr, xResolve, xReject, xEventListener) => {
            const FWUPG_START_RETCODES = {
                STARTED: 'STARTED',
                BUSY: 'BUSY'
            };

            // Call a function when the state changes.
            if (xXhr.readyState === 4) {
                if (xXhr.status >= 200 && xXhr.status < 300) {
                    try {
                        that.fireProgressEvent(xEventListener,
                            new EC9xSFUProgressEvent(EC9xSFU_STEPS[1], 100), true);

                        const resp = JSON.parse(xXhr.response);
                        switch (resp.state) {
                            case FWUPG_START_RETCODES.STARTED: {
                                let expectedDuration = resp['expected-duration'] ? parseInt(resp['expected-duration'], 10) : 300;
                                if (Number.isNaN(expectedDuration)) {
                                    expectedDuration = 300;
                                }
                                const updateId = resp['update-id'] ? resp['update-id'] : '0';
                                xResolve({ expectedDuration, updateId });
                                break;
                            }

                            case FWUPG_START_RETCODES.BUSY:
                                xReject(
                                    new Error('Another firmware update is in progress. Please try again later!')
                                );
                                break;

                            default:
                                xReject(
                                    new Error('Failed starting firmware updating!')
                                );
                        }
                    } catch (e) {
                        xReject(
                            new Error(`Error happened during starting firmware updating! - ${e.toString()}`)
                        );
                    }
                } else {
                    xReject(new Error(`Failed uploading firmware to scanner! - HTTP ${xXhr.status}`));
                }
            }
        };

        this.doPollFirmwareInstalling = (xScannerUrl, xUpdateId,
            xExpectedDuration, xEventListener) => {
            const FWUPG_STATUS = {
                IDLE: 'IDLE',
                RUNNING: 'RUNNING',
                DONE: 'COMPLETED',
                REBOOT: 'REBOOT',
                ERR_FILE: 'ERR_FILEFORMAT',
                ERR_INSTALL: 'ERR_INSTALL',
                ERR_OTHER: 'ERROR_OTHER',
            };

            const createUpdateError = (xVerbg, xResp = null) => {
                const details = [];

                if (xResp && xResp.error) {
                    details.push(xResp.error);
                }

                if (xResp && xResp.message) {
                    details.push(`!!${xResp.message}`);
                }

                if (xResp && xResp.progresses) {
                    xResp.progresses.forEach((logLn) => details.push(logLn));
                }

                return new ScannerFirmwareUpdateFailure(xVerbg, details);
            };

            that.fireProgressEvent(xEventListener,
                new EC9xSFUProgressEvent(EC9xSFU_STEPS[2], 0), true);

            return new Promise((resolve, reject) => {
                const PROGRESS_INTERVAL = 2000;
                const PROGRESS_EXPECTED_COUNT = (xExpectedDuration * 1000) / PROGRESS_INTERVAL;
                const RETRY_POLLING = 'EC9xNSSFU-RETRY.POLLING';

                let progressCount = 0;

                const dummyProgress = setInterval(() => {
                    progressCount += 1;
                    const progressEvent = new EC9xSFUProgressEvent(
                        EC9xSFU_STEPS[2],
                        (progressCount <= (PROGRESS_EXPECTED_COUNT * 0.95) ? ((progressCount / PROGRESS_EXPECTED_COUNT) * 100) : 96)
                    );

                    that.fireProgressEvent(xEventListener, progressEvent);
                }, PROGRESS_INTERVAL);

                const watchDog = setTimeout(() => {
                    reject(new ScannerFirmwareUpdateFailure('Firmware update failed - timed out!'));
                }, 1800000);

                const doReject = (xObj) => {
                    this.status = this.STATUSES.DONE;
                    clearInterval(dummyProgress);
                    clearTimeout(watchDog);
                    reject(xObj);
                };

                const doResolve = (xObj) => {
                    this.status = this.STATUSES.DONE;
                    clearInterval(dummyProgress);
                    clearTimeout(watchDog);
                    resolve(xObj);
                };

                const pollUpdateStatusOnce = () => {
                    /*!! Legacy API, Need to rollback when we backport*/
                    timedGet(`${xScannerUrl}/webactions/admin/upgrade.status?id=${xUpdateId || '0'}`, {}, 8000).then((cPollingResp) => {

                        // timedGet(`${xScannerUrl}/dashboard/SVC/FwUpdate/Status?id=${xUpdateId || '0'}`, {}, 8000).then((cPollingResp) => {
                        switch (cPollingResp.status) {
                            case 200:
                                return cPollingResp.data;

                            case 502:
                            case 503:
                            case 504:
                                return Promise.reject(RETRY_POLLING);

                            default:
                                return Promise.reject(createUpdateError(`Error happened during firmware update! Update is aborted. - HTTP ${cPollingResp.status}`));
                        }
                    }).then((cPollingJson) => {
                        try {
                            switch (cPollingJson.state) {
                                case FWUPG_STATUS.IDLE: {
                                    return Promise.reject(createUpdateError('No update is currently in progress!', cPollingJson));
                                }

                                case FWUPG_STATUS.RUNNING:
                                case FWUPG_STATUS.REBOOT: {
                                    setTimeout(pollUpdateStatusOnce, 1000);
                                    return;
                                }

                                case FWUPG_STATUS.DONE: {
                                    clearInterval(dummyProgress);

                                    that.fireProgressEvent(xEventListener,
                                        new EC9xSFUProgressEvent(EC9xSFU_STEPS[2], 100), true);
                                    doResolve(cPollingJson);
                                    return;
                                }

                                case FWUPG_STATUS.ERR_FILE: {
                                    return Promise.reject(createUpdateError('Update package is invalid!', cPollingJson));
                                }

                                case FWUPG_STATUS.ERR_INSTALL: {
                                    return Promise.reject(createUpdateError('Unable to install the update package!', cPollingJson));
                                }

                                default: {
                                    return Promise.reject(createUpdateError('Error happened during firmware update! Update is aborted.', cPollingJson));
                                }
                            }
                        } catch (e) {
                            return Promise.reject(new ScannerFirmwareUpdateFailure(`Error happened during polling update status - ${e.message}`));
                        }
                    }).catch((pollingError) => {
                        if (pollingError === RETRY_POLLING || !(pollingError instanceof ScannerFirmwareUpdateFailure)) {
                            setTimeout(pollUpdateStatusOnce, 1000);
                        } else {
                            // this.status = this.STATUSES.DONE;
                            doReject(pollingError);
                        }
                    });
                };

                pollUpdateStatusOnce();
            });
        };
    }

    /**
     * @override
     */
    doGetExectorType() {
        return 'API';
    }
}


class EC9xNSAjaxUpdateWorker extends EC9xNSAPIBaseWorker {
    constructor(scannerUrl, update) {
        super();
        this.scannerUrl = scannerUrl;
        this.pkgUrl = update.pkgURL;
    }

    /**
     * @override
     * @param {*} xProgressListener 
     */
    doStartUpdate(xProgressListener) {
        const that = this;

        if (this.status !== this.STATUSES.IDLE) {
            throw new Error('Updating has been stared');
        }
        this.status = this.STATUSES.RUNING;

        return this.doRetrieveBinaryAsArray(this.pkgUrl, xProgressListener).then(
            (cPkgData) => {
                // This function uploads with XMLHttpRequest as it supports the upload progress event.

                that.fireProgressEvent(xProgressListener,
                    new EC9xSFUProgressEvent(EC9xSFU_STEPS[1], 0), true);

                return new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();

                    xhr.open('POST', `${this.scannerUrl}/webactions/admin/update/uploadbin`, true);
                    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
                    xhr.setRequestHeader('x-RDMClientUTCTime', getISODateString2());

                    if (xhr.upload) {
                        that.regXHRListener(xhr.upload, 'progress', (cProgressEvt) => {
                            if (cProgressEvt.lengthComputable && cProgressEvt.total > 0) {
                                that.fireProgressEvent(xProgressListener,
                                    new EC9xSFUProgressEvent(EC9xSFU_STEPS[1],
                                        ((cProgressEvt.loaded / cProgressEvt.total) * 100)));
                            }
                        });
                    }

                    that.regXHRListener(xhr, 'readystatechange', () => {
                        that.doHandleUploadResp(xhr, resolve, reject, xProgressListener);
                    });
                    xhr.send(cPkgData);
                });
            }
        ).then(
            ({ updateId, expectedDuration }) => this.doPollFirmwareInstalling(
                this.scannerUrl, updateId, expectedDuration, xProgressListener
            )
        );
    }

}


class EC9xNSFormUpdateWorker extends EC9xNSAPIBaseWorker {
    constructor(scannerUrl, updateMetaList) {
        super();
        this.scannerUrl = scannerUrl;
        this.updateMetaList = updateMetaList;
    }

    doStartUpdate(xProgressListener, updateOptions) {
        const that = this;
        let updatePackages;

        if (this.status !== this.STATUSES.IDLE) {
            throw new Error('Updating has been stared');
        }
        this.status = this.STATUSES.RUNING;

        updateOptions = updateOptions || {};

        if ('toInstall' in updateOptions && Array.isArray(updateOptions.toInstall)) {
            if (updateOptions.toInstall.length === 0) {
                throw new Error('Empty update is selected.');
            }
            updatePackages = this.updateMetaList.filter((entry) =>
                updateOptions.toInstall.includes(entry.getUpdateId())
            );
        } else {
            // updatePackages = this.updateMetaList.slice(0,1);
            updatePackages = this.updateMetaList;
        }

        let downloadPercents = updatePackages.map(() => 0);
        const downloadEventDecorator = (index, xEvent) => {
            downloadPercents[index] = xEvent.currentStepPercent;

            that.fireProgressEvent(xProgressListener,
                new EC9xSFUProgressEvent(
                    EC9xSFU_STEPS[0],
                    downloadPercents.reduce(((total, value) => total + value / 3), 0)
                )
            );
        };

        return Promise.all(updatePackages.map(
            (item, index) => this.doRetrieveBinaryAsBlob(
                item.getUpdateUrl(), downloadEventDecorator.bind(that, index)
            )
        )).then((pkgBlobs) => {
            const updatePkgs = pkgBlobs.map((blob, index) => ({
                fn: basefile(that.updateMetaList[index].getUpdateUrl()),
                blob
            }));

            that.fireProgressEvent(xProgressListener,
                new EC9xSFUProgressEvent(EC9xSFU_STEPS[1], 0), true);

            return new Promise((resolve, reject) => {
                const formData = new FormData();

                updatePkgs.forEach((pkg, index) => {
                    formData.append(`pkg${index}`, pkg.blob, pkg.fn);
                });

                const xhr = new XMLHttpRequest();

                xhr.open('POST', `${that.scannerUrl}/SVC/update/v2`, true);
                xhr.setRequestHeader('x-RDMClientUTCTime', getISODateString2());
                // xhr.setRequestHeader('Content-Type', 'multipart/form-data');

                if (xhr.upload) {
                    that.regXHRListener(xhr.upload, 'progress', (cProgressEvt) => {
                        if (cProgressEvt.lengthComputable && cProgressEvt.total > 0) {
                            that.fireProgressEvent(xProgressListener,
                                new EC9xSFUProgressEvent(EC9xSFU_STEPS[1],
                                    ((cProgressEvt.loaded / cProgressEvt.total) * 100)
                                )
                            );
                        }
                    });
                }

                that.regXHRListener(xhr, 'readystatechange', () => {
                    that.doHandleUploadResp(xhr, resolve, reject, xProgressListener);
                });

                xhr.send(formData);
            });
        }).then(({ updateId, expectedDuration }) => {
            return this.doPollFirmwareInstalling(
                this.scannerUrl, updateId, expectedDuration, xProgressListener
            );
        });
    }
}


/**********************************************************
 * Support Legacy SFU API (One at a time) 
 **********************************************************/

class EC9xSfuUpdate extends EC9xSfuUpdateMeta {
    constructor(update) {
        super();
        this.updateMeta = new EC9xSfuUpdateMeta(update);
        this.exector = null;

        const that = this;
        this.setExector = (v) => {
            that.exector = v;
            return that;
        };
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateId() {
        return this.updateMeta.getUpdateId();
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateType() {
        return this.updateMeta.getUpdateType();
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateVersion() {
        return this.updateMeta.getUpdateVersion();
    }

    /**
     * @override
     * @deprecated
     */
    isUpdateRequired() {
        return this.updateMeta.isUpdateRequired();
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateName() {
        return this.updateMeta.getUpdateName();
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateDetails() {
        return this.updateMeta.getUpdateDetails();
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateLicenseHtml() {
        return this.updateMeta.getUpdateLicenseHtml();
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateLicenseUrl() {
        return this.updateMeta.getUpdateLicenseUrl();
    }

    /**
     * @override
     * @deprecated
     */
    getUpdateUrl() {
        return this.updateMeta.getUpdateUrl();
    }

    /**
     * @override
     * @deprecated
     */
    getInstallBeforeDate() {
        return this.updateMeta.getInstallBeforeDate();
    }

    /**
     *  @abstract
     */
    startUpdate(xProgressListener) {
        if (!this.exector) {
            throw new Error('Method "startUpdate" is not implemented!');
        }

        return this.exector.doStartUpdate(xProgressListener);
    }

    getInstallationType() {
        if (!this.exector) {
            throw new Error('Method "getInstallationType" is not implemented!');
        }

        return this.exector.doGetExectorType();
    }
}


class EC9xSfuManualUpdateLegacy extends EC9xSfuUpdate {
    constructor(scannerUrl, update) {
        super(update);
        this.setExector(new EC9xSfuManualUpdateWorker(scannerUrl));
    }
}


class EC9xSfuAjaxUpdateLegacy extends EC9xSfuUpdate {
    constructor(scannerUrl, update) {
        super(update);
        this.setExector(new EC9xNSAjaxUpdateWorker(scannerUrl, update));
    }
}


class EC9xSfuFormUpdateLegacy extends EC9xSfuUpdate {
    constructor(scannerUrl, update) {
        super(update);
        this.setExector(new EC9xNSFormUpdateWorker(scannerUrl, [this.updateMeta]));
    }
}


function createUpdateObjectV1(deviceInfo, updateLst) {
    const currentFwVerion = deviceInfo.versions['Firmware'];
    const deviceURL = deviceInfo.deviceURL;

    switch (deviceInfo.deviceType.toUpperCase()) {
        case 'EC9600': {
            if (compareSemanticVersion(currentFwVerion, '1.2.1.272') <= 0) {
                for (const entry of updateLst) {
                    if (entry && entry.type === 'Firmware') {
                        return new EC9xSfuManualUpdateLegacy(deviceURL, entry);
                    }
                }
                return null;
            } else if (compareSemanticVersion(currentFwVerion, '1.2.1.283') <= 0) {
                for (const entry of updateLst) {
                    if (entry) {
                        return new EC9xSfuAjaxUpdateLegacy(deviceURL, entry);
                    }
                }
            } else {
                for (const entry of updateLst) {
                    if (entry) {
                        return new EC9xSfuFormUpdateLegacy(deviceURL, entry);
                    }
                }
            }
            break;
        }

        case 'EC9700':
        case 'EC9700I': {
            for (const entry of updateLst) {
                if (entry) {
                    return new EC9xSfuFormUpdateLegacy(deviceURL, entry);
                }
            }
            break;
        }

        default:
            break;
    }

    return null;
}


/**********************************************************
 * EC9700 Update API
 **********************************************************/

class EC9xSfuCollectedUpdate {
    constructor(updates) {
        this.updateMetaList = updates.map((value) => new EC9xSfuUpdateMeta(value));
        this.exector = null;

        const that = this;
        this.setExector = (v) => {
            that.exector = v;
            return that;
        };
    }

    /**
     * @abstract
     */
    getUpdates() {
        return [...this.updateMetaList];
    }

    /**
     * @abstract
     */
    isRequired() {
        for (const anUpdate of this.updateMetaList) {
            if (anUpdate.isUpdateRequired()) {
                return true;
            }
        }
        return false;
    }

    /**
     *  @abstract
     */
    // eslint-disable-next-line no-unused-vars
    startUpdate(xProgressListener, updateOptions = null) {
        if (!this.exector) {
            throw new Error('Method "startUpdate" is not implemented!');
        }

        return this.exector.doStartUpdate(xProgressListener, updateOptions);
    }

    getInstallationType() {
        if (!this.exector) {
            throw new Error('Method "getInstallationType" is not implemented!');
        }

        return this.exector.doGetExectorType();
    }
}


class EC9xSfuManualUpdate extends EC9xSfuCollectedUpdate {
    constructor(scannerUrl, update) {
        super([update]);
        this.setExector(new EC9xSfuManualUpdateWorker(scannerUrl));
    }
}


class EC9xSfuAjaxUpdate extends EC9xSfuCollectedUpdate {
    constructor(scannerUrl, update) {
        super([update]);
        this.setExector(new EC9xNSAjaxUpdateWorker(scannerUrl, update));
    }
}


class EC9xSfuFormAPIUpdate extends EC9xSfuCollectedUpdate {
    constructor(scannerUrl, updateLst) {
        super(updateLst);
        this.setExector(new EC9xNSFormUpdateWorker(scannerUrl, this.updateMetaList));
    }
}


function createUpdateObjectV2(deviceInfo, updateLst) {
    const currentFwVerion = deviceInfo.versions['Firmware'];
    const deviceURL = deviceInfo.deviceURL;

    switch (deviceInfo.deviceType.toUpperCase()) {
        case 'EC9600': {
            if (compareSemanticVersion(currentFwVerion, '1.2.1.272') <= 0) {
                for (const item of updateLst) {
                    if (item && item.type === 'Firmware') {
                        return new EC9xSfuManualUpdate(deviceURL, item);
                    }
                }
                return null;
            } else if (compareSemanticVersion(currentFwVerion, '1.2.1.283') <= 0) {
                for (const item of updateLst) {
                    if (item) {
                        return new EC9xSfuAjaxUpdate(deviceURL, item);
                    }
                }
            } else {
                return new EC9xSfuFormAPIUpdate(deviceURL, updateLst);
            }
            break;
        }

        case 'EC9700':
        case 'EC9700I':
            return new EC9xSfuFormAPIUpdate(deviceURL, updateLst);

        default:
            logError(`Unknown device type:${deviceInfo.deviceType}`);
            break;
    }

    return null;
}


function createDashboardUpdateObjectV2(deviceInfo, updateLst) {
    return new EC9xSfuFormAPIUpdate(deviceInfo.deviceURL, updateLst);
}


/**********************************************************
 * Dashboard File Update
 **********************************************************/

class EC9xNSFileUpdateWorker extends EC9xNSAPIBaseWorker {
    constructor(scannerUrl, fileObj) {
        super();
        this.fileObj = fileObj;
        this.scannerUrl = scannerUrl;
    }

    doStartUpdate(xProgressListener) {
        const that = this;

        return new Promise((resolve, reject) => {
            const formData = new FormData();

            formData.append(
                'pkg0',
                this.fileObj,
                this.fileObj.name ? basefile(this.fileObj.name) : 'file-update.bin'
            );

            const xhr = new XMLHttpRequest();

            xhr.open('POST', `${that.scannerUrl}/SVC/update/v2`, true);
            xhr.setRequestHeader('x-RDMClientUTCTime', getISODateString2());
            // xhr.setRequestHeader('Content-Type', 'multipart/form-data');

            if (xhr.upload) {
                that.regXHRListener(xhr.upload, 'progress', (cProgressEvt) => {
                    if (cProgressEvt.lengthComputable && cProgressEvt.total > 0) {
                        that.fireProgressEvent(xProgressListener,
                            new EC9xSFUProgressEvent(EC9xSFU_STEPS[1],
                                ((cProgressEvt.loaded / cProgressEvt.total) * 100)
                            )
                        );
                    }
                });
            }

            that.regXHRListener(xhr, 'readystatechange', () => {
                that.doHandleUploadResp(xhr, resolve, reject, xProgressListener);
            });

            xhr.send(formData);
        }).then(({ updateId, expectedDuration }) => {
            return this.doPollFirmwareInstalling(
                this.scannerUrl, updateId, expectedDuration, xProgressListener
            );
        });
    }
}


class EC9xSfuFileUpdate {
    constructor(deviceURL, fileObj) {
        this.exector = new EC9xNSFileUpdateWorker(deviceURL, fileObj);
    }

    /**
     *  @abstract
     */
    // eslint-disable-next-line no-unused-vars
    startUpdate(xProgressListener) {
        return this.exector.doStartUpdate(xProgressListener);
    }
}

function createManualUpdateObject(deviceURL, fileObj) {
    return new EC9xSfuFileUpdate(deviceURL, fileObj);
}


export {
    EC9xSfuUpdate, EC9xSfuCollectedUpdate,
    compareSemanticVersion, createUpdateObjectV1, createUpdateObjectV2, createDashboardUpdateObjectV2,
    createManualUpdateObject
}
